import axios from "axios";
import { DEV_AUTH_URL } from "../config";

import ConsoleLocalStorage from "../storage/storage";

export default class DevAuthAPI {
  instance = axios.create({
    baseURL: DEV_AUTH_URL,
  });

  refreshToken(data) {
    return this.instance.post("oauth/refresh", data);
  }

  developerLogin(data) {
    return this.instance.post("oauth/login", data);
  }

  developerSignUp(data) {
    return this.instance.post("oauth/signup", data);
  }

  resendVerificationEmail(data) {
    return this.instance.post("oauth/email-verification", data);
  }

  forgotPassword(data) {
    return this.instance.post("oauth/forgot-password", data);
  }

  getDeveloper(id) {
    return this.instance.get("developer/" + id, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }
  getAllUser() {
    return this.instance.get("developer-admin/", {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }
  deleteUser(id) {
    return this.instance.patch("developer-admin/remove-user/" + id,{}, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }
  // get available roles
  getAvailableRoles(){
    return this.instance.get("developer-admin/roles", {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }

  assignOwnerRole(id, data) {   //Not being used
    return this.instance.put("dc/developers/" + id, data);
  }
  updateDev(devid, data) {
    return this.instance.patch("developer/" + devid, data, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }
  changePass(devid, data) {
    return this.instance.patch("oauth/change-password/" + devid, data, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }

  inviteUser(data) {
    return this.instance.post("developer-admin/invite-user/", data, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }

  resendInviteUser(data) {
    return this.instance.post("developer-admin/resend-invite-user/", data, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }
  
  assignRole(devid, data) {
    return this.instance.put("developer-admin/" + devid, data, {
      headers: {
        Authorization: "Bearer " + ConsoleLocalStorage.getAccessToken(),
      },
    });
  }

  getCountries(){
    return this.instance.get("address/countries",{
    });
  }
  getStates(id){
    return this.instance.get(`address/countries/${id}/states`,{
    });
  }
  getCity(id){
    return this.instance.get(`address/states/${id}/cities`,{
    });
  }
}
